/**
 * RELATÓRIO DE MOVIMENTAÇÃO — o kardex: para onde foi cada grama.
 *
 * Abas: Kardex, Teórico × real, Perdas e Transferências.
 *
 * Mesma dependência do Estoque, e mesmo desfecho: **não existe tabela de
 * movimento em acd nem em aod**, então o kardex não tem o que percorrer. As
 * colunas aparecem vazias e explicadas, com o diagnóstico medido.
 *
 * De todos os relatórios, este é o que mais sofreria com número inventado: o
 * kardex é a peça que o dono usa para descobrir FURO (produto que sai do
 * estoque e não sai na venda). Um kardex de zeros afirmaria que não houve furo
 * nem perda — é uma mentira com consequência.
 *
 * SÓ LEITURA (§5.1).
 */
import React from "react";
import { useSearchParams } from "react-router-dom";
import * as AlfredoStyles from "../styles/components/MovimentReport";
import * as EstilosDeRelatorio from "../styles/components/reports/RelatorioComum";
import * as AlfredoComponents from "./";
import { relatorioService } from "../services/relatorio.service";
import { useRelatorio } from "../hooks/useRelatorio";

const CAMPOS = ["de", "ate", "aba"];

const buscarMovimentacao = relatorioService.movimentacao.bind(relatorioService);

const MovimentReport: React.FC = () => {
  const [parametrosDaUrl] = useSearchParams();
  const abaAtual = parametrosDaUrl.get("aba") || "kardex";

  const relatorio = useRelatorio(buscarMovimentacao, CAMPOS);
  const abas = relatorio.envelope?.abas ?? [];

  return (
    <AlfredoStyles.MovimentReportContainer>
      <AlfredoStyles.Card>
        <AlfredoStyles.Icon>swap_horiz</AlfredoStyles.Icon>
        <AlfredoStyles.Title>Relatório de Movimentação</AlfredoStyles.Title>

        <AlfredoComponents.CarimboDoDado
          carimbo={relatorio.envelope?.carimbo}
          fonte={relatorio.envelope?.fonte}
          semVenda
        />

        {abas.length > 0 && (
          <EstilosDeRelatorio.Abas>
            {abas.map((aba) => (
              <EstilosDeRelatorio.Aba
                key={aba.id}
                type="button"
                ativa={aba.id === abaAtual}
                onClick={() => relatorio.mudarFiltro("aba", aba.id)}
              >
                {aba.titulo}
              </EstilosDeRelatorio.Aba>
            ))}
          </EstilosDeRelatorio.Abas>
        )}

        <AlfredoComponents.AvisosDoRelatorio avisos={relatorio.envelope?.avisos} />

        <AlfredoComponents.EstadoBloqueado dados={relatorio.envelope?.bloqueado} />

        <AlfredoComponents.DynamicTable
          tableType={0}
          handleOpenModal={() => undefined}
          rows={relatorio.linhas}
          columns={relatorio.colunas}
          getRowId={(linha) => String(linha.chave ?? "")}
          title={abas.find((aba) => aba.id === abaAtual)?.titulo ?? "Kardex"}
          hideCreateButton
          hideImportButton
          hideRowActions
          isLoading={relatorio.carregando}
          error={relatorio.erro}
          emptyMessage="Não há movimento registrado — e isso não é o mesmo que movimento zero. O motivo está acima."
        />

        {relatorio.envelope && (
          <AlfredoComponents.RodapeDaFonte envelope={relatorio.envelope} />
        )}
      </AlfredoStyles.Card>
    </AlfredoStyles.MovimentReportContainer>
  );
};

export default MovimentReport;
